import styles from './AddButton.module.scss';
import { FC, useState } from 'react';
import { Button, Icon } from '@mui/material';

type TAddFamilyButtonProps = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
};

const AddButton: FC<TAddFamilyButtonProps> = (props) => {
    const { label, onClick, disabled } = props;
    const [isActive, setIsActive] = useState(false);

    return (
        <Button
            variant="text"
            onMouseEnter={() => setIsActive(true)}
            onMouseLeave={() => setIsActive(false)}
            onClick={onClick}
            className={styles.button}
            startIcon={<Icon color={`${disabled ? 'disabled' : 'primary'}`}>add_circle</Icon>}
            disabled={disabled ? disabled : undefined}
        >
            {label}
        </Button>
    );
};

export default AddButton;
